
export default [
    {
        path: '/Index',
        name:'Index',
        meta: { 
          title: '首页',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/Index/Index'),
    },
    {
      path: '/Course',
        name:'Course',
        meta: { 
          title: '全部课程',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/Course/Course'),
    },
    {
      path: '/Teacher',
        name:'Teacher',
        meta: { 
          title: '全部老师',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/Teacher/Teacher'),
    },
    {
      path: '/TeacherDetails',
        name:'TeacherDetails',
        meta: { 
          title: '教师详情',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/TeacherDetails/TeacherDetails'),
    },
    {
      path: '/CourseDetails',
        name:'CourseDetails',
        meta: { 
          title: '课程详情',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/CourseDetails/CourseDetails'),
    },
    {
      path: '/registerNow',
        name:'registerNow',
        meta: { 
          title: '立即报名',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/registerNow/registerNow'),
    },
    {
      path: '/Remark',
        name:'Remark',
        meta: { 
          title: '报名备注',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/registerNow/Remark'),
    },
    {
      path: '/SelectStudents',
        name:'SelectStudents',
        meta: { 
          title: '选择学员',
        //   keepAlive: true,
        //   requireAuth:true
        },
          component: () => import('@/views/SelectStudents/SelectStudents'),
    }
      

]



// WEBPACK FOOTER //
// ./src/router/course/Index.js